import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import classes from './CyberAssessment.module.scss'
import useAssessment from '../../../../customHooks/useAssessment'
import { HtmlSafeElement } from '../../../shared/HtmlSafeElement'
import Icon from '../../../../Icon'
import Button from '../../../shared/ComponentLibrary/RButton'
import PageHeading from '../../../shared/PageHeading'
import BreadcrumbsPath from '../../../shared/BreadcrumbsPath'


const CyberAssessmentInstructions = () => {
  const navigate = useNavigate()

  const { getCyberIntroPage } = useAssessment()
  const [introPageData, setIntroPageData] = useState<ICyberAssessmentIntroduction>()
  const [pageNumber, setPageNumber] = useState<number>(1)

  useEffect(() => {
    getCyberIntroPage(pageNumber, setIntroPageData)
  }, [pageNumber])

  const nextPage = () => setPageNumber((current) => current + 1)
  const previousPage = () => setPageNumber((current) => current - 1)

  return(
    <div className={classes.assessment_container}>
      <div className={classes.header}>
        <PageHeading title='Cyber Skills Assessment Instructions' icon='testResults' />
        <BreadcrumbsPath />
      </div>
      <div className={classes.page_count}>Page {pageNumber} / 4</div>
      {
        introPageData &&
        <div className={classes.introduction}>
          <div className={classes.main_heading}>
            <HtmlSafeElement element="h4" content={introPageData.mainHeading}  />
            <HtmlSafeElement element="p" content={introPageData.mainHeadingContent}  />
          </div>

          {
            introPageData.subHeadingContentList &&
            introPageData.subHeadingContentList.subHeadingContent.map((subHeading, index) => {
              return(
                <div key={index}>
                  <HtmlSafeElement element="h4" content={subHeading.heading}  />
                  <HtmlSafeElement element="p" content={subHeading.content}  />
                </div>
              )
            })
          }

          <div>
            <HtmlSafeElement element='p' content={introPageData.source}/>
          </div>
        </div>
      }
      <div className={classes.navigation_section}>
        <hr className={classes.divider}/>
        <div className={classes.navigation_buttons}>
          <div className={classes.back}>
            <Button onClickMethod={previousPage} hidden={pageNumber <= 1}>
              <Icon name='longArrowLeft' color='#FFF' />
              Back
            </Button>
          </div>
          <div className={classes.next}>
            <Button onClickMethod={nextPage} hidden={pageNumber >= 4}>
              Next
              <Icon name='longArrowLeft' color='#FFF' transform />
            </Button>
            <Button
              innerText='Take the Assessment'
              size='small'
              onClickMethod={() => navigate('/assessment/cyber/begin')}
              hidden={pageNumber < 4}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CyberAssessmentInstructions
